<template>
  <div class="respons-detail-table">
    <vxe-table
      class="atb-table header-table edit-table border-table disable-ellipsis"
      border="full"
      auto-resize
      resizable
      :data="tableData"
      ref="detailTable"
      :merge-cells="[{ row: 0, col: 0, rowspan: 1, colspan: 4}]"
      :row-class-name="setRowClass"
      :edit-config="{ trigger: 'click', mode: 'row', activeMethod: editActived }"
      @edit-closed="editClosed"
      @edit-actived="activeRow"
      @cell-click="expandRow"
      :edit-rules="validRules"
      :scroll-y="{enabled: false}"
    >
      <vxe-table-column
        width="400"
        field="workItemContent"
        :title="tableDetail.headerTitle"
        :edit-render="{ enabled: isEditable, autofocus: '.el-textarea__inner' }"
      >
        <template #edit="{ row, rowIndex }">
          <template v-if="rowIndex > 0">
            <el-input
              type="textarea"
              :maxlength="$config.input.textareaMaxLength"
              :autosize="{ maxRows: 8 }"
              placeholder="请输入内容"
              v-model="row.workItemContent"
            ></el-input>
          </template>
        </template>
        <template #default="{row, rowIndex}">
          <template v-if="rowIndex === 0">
            <div class="type-add atb-flex atb-flex-justify-between atb-flex-items-center">
              <div>
                <i @click="expandTable" :class="[expandStatus ? 'icon-arrow-up-bold' : 'icon-arrow-down-bold-copy', 'fold']"></i>
                <span @click="expandTable">{{ tableDetail.typeText }}</span>
                <i v-throttle v-if="isEditable && !addDisable" @click.stop="addRow" class="icon-add"></i>
              </div>
              <span v-throttle v-if="isEditable && !addDisable" @click.stop="addRow(row)">新增</span>
            </div>
          </template>
          <template v-else>
            <div class="atb-flex atb-flex-items-center">
              <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.workItemContent }}</div>
            </div>
          </template>
        </template>
      </vxe-table-column>

      <vxe-table-column
        min-width="200"
        field="yearTarget"
        title="本年度应达标的目标"
        :edit-render="{ enabled: isEditable, autofocus: '.el-textarea__inner' }"
      >
        <template #default="{row}">
          <div :class="[row.expandRowFlag ? 'maxheight' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.yearTarget }}</div>
        </template>
        <template #edit="{ row }">
          <el-input
            type="textarea"
            :maxlength="$config.input.textareaMaxLength"
            :autosize="{ maxRows: 8 }"
            placeholder="请输入内容"
            v-model="row.yearTarget"
          ></el-input>
        </template>
      </vxe-table-column>
      <vxe-table-column
        width="280"
        field="weight"
        :controls="false"
        :title="`每项职责所占权重(${tableDetail.weight}%)`"
        :edit-render="{ enabled: isEditable, autofocus: '.el-input__inner' }"
      >
        <template #edit="{ row }">
          <el-autocomplete @change="regWeight(row)" @blur="blurWeight(row)" v-model.trim="row.weight" :fetch-suggestions="weightSearch" popper-class="personal-response-weight-popper"></el-autocomplete>
        </template>
      </vxe-table-column>
      <vxe-table-column field="" title="操作" fixed="right" width="120" class-name="operation" v-if="isEditable">
        <template #default="scope">
          <div v-if="isEditable && !addDisable">
            <el-tooltip class="item" effect="dark" v-if="scope.row.itemType != 2" content="保存" placement="bottom">
              <i v-throttle class="icon-baocun" @click.stop="save(scope.row, scope.rowIndex)"></i>
            </el-tooltip>
            <el-tooltip class='item' effect='dark' v-if="scope.row.itemType != 2 && scope.row.itemType != 1" content='复制' placement="bottom">
              <i v-throttle class='icon-copy' @click.stop='copyData(scope.row, scope.rowIndex).then(()=>{editActived({ row:scope.row, rowIndex:scope.rowIndex })})'></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" v-if="scope.row.itemType != 2 && scope.row.itemType != 1" content="删除" placement="bottom">
              <i v-throttle class="icon-close delete" @click.stop="deleteData(scope.row, scope.rowIndex)"></i>
            </el-tooltip>
          </div>
        </template>
      </vxe-table-column>
      
    </vxe-table>
  </div>
</template>
<script>
import _ from 'lodash';
export default {
  name: 'DetailTable',
  props: {
    workId: String,
    tableDetail: {
      type: Object,
      default: () => ({})
    },
    isEditable: Boolean,
    isAllPending: Boolean,
  },
  data() {
    return {
      mergeCells: [{ row: 0, col: 0, rowspan: 1, colspan: 4}],
      tableData: [{}],
      cloneTableData: [],
      expandStatus: true,
      validRules: {
        workItemContent: [{ required: true, message: `"${this.tableDetail.headerTitle}"为必填项` }],
        yearTarget: [{ required: true, message: '"本年度应达标的目标"为必填项' }],
        weight: [
          { required: true, message: '"权重"为必填项'},
          {
            validator: function({cellValue, row, column}) {
              if (row.itemType == 1) {
                const rangeArr = row.innerWeightRange || [];
                const val = Number(cellValue);
                if (rangeArr.length > 0 && (val < rangeArr[0] || val > rangeArr[1])) {
                  return new Error('权重范围是' + rangeArr.join('-'));
                }
              }
            }
          }
        ],
      },

      activedRow: {},
      rowIndex: -1,

      saveStatus: '',
      timeoutSave: '',
      timeoutAutoSave: '',

      pending: false, // 正在保存

      addDisable: false,
    }
  },
  computed: {
    
  },
  watch: {
    'tableDetail.tableData': {
      handler(newVal) {
        this.tableData = [{}];
        const tableData = _.cloneDeep(newVal)
        this.tableData.push(...tableData);
        if (this.tableDetail.workClassify == 10) {
          this.tableData.forEach(item => {
            if (item.isInner) {
              // 企业文化如果存在内置的，则不允许新增删除
              // 内置的工作项类型为1的可编辑权重，为2时不可编辑
              this.addDisable = true;
            }
          })
        }
      },
      immediate: true,
    },
    pending(newVal) {
      this.$emit('update:isAllPending', newVal);
    }
  },
  mounted() {
    this.timer && clearInterval(this.timer);
  },
  methods: {
    newRow() {
      return {
        "id": null,
        "workId": this.workId,
        "workClassify": this.tableDetail.workClassify,
        "workItemNo": '',
        "workItemContent": '',
        "yearTarget": "",
        "weight": null,
      }
    },
    getTableData() {
      return this.tableData.concat(this.cloneTableData).filter(item => item.workId);
    },
    validateTable() {
      return this.$refs.detailTable.validate(this.tableData.filter(item => item.workId)).catch((err) => err);
    },
    refreshTable() {
      this.$refs.detailTable && this.$refs.detailTable.updateData(this.tableData);
    },
    regWeight(row) {
      let reg = new RegExp('^([1-9]|[1-9]\\d|100)$');
      if (!reg.test(row.weight)) {
        if (row.weight - 0 > 100) {
          row.weight = 100;
        } else {
          row.weight = 1;
        }
      }
    },
    blurWeight(row) {
      if (row.weight === '') {
        row.weight = null;
      }
    },
    weightSearch(queryString, cb) {
      let programList = [{ value: 5 }, { value: 10 }, { value: 15 }, { value: 20 }, { value: 25 }, { value: 30 }];
      // 调用 callback 返回建议列表的数据
      cb(programList);
    },
    setRowClass({ rowIndex }) {
      if (rowIndex == 0) {
        return 'main-row';
      }
    },
    expandTable() {
      this.expandStatus = !this.expandStatus;
      if (this.expandStatus) {
        this.tableData = _.cloneDeep(this.cloneTableData);
        this.cloneTableData = [{}];
      } else {
        this.cloneTableData = _.cloneDeep(this.tableData);
        this.tableData = [{}];
      }
    },
    expandRow({rowIndex}) {
      if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
      this.refreshTable();
    },
    // 表格显示
    openTable() {
      if (this.expandStatus) return;
      this.expandStatus = true;
      this.tableData = _.cloneDeep(this.cloneTableData);
      this.cloneTableData = [{}];
    },
    // 表格隐藏
    closeTable() {
      if (!this.expandStatus) return;
      this.expandStatus = false;
      this.cloneTableData= _.cloneDeep(this.tableData);
      this.tableData = [{}];
    },
    // 多行文字的数据展开
    openAllRow() {
      this.tableData.concat(this.cloneTableData).filter(item => item.workId).forEach(item => {
        item.expandRowFlag = true;
      });
      this.refreshTable();
    },
    // 多行文字的数据隐藏
    closeAllRow() {
      this.tableData.concat(this.cloneTableData).filter(item => item.workId).forEach(item => {
        item.expandRowFlag = false;
      });
      this.refreshTable();
    },
    editActived({ row, rowIndex, column }) {
      if (row.itemType == 2 || (row.itemType == 1 && column.property !== 'weight')) {
        return false;
      }
      return this.isEditable && rowIndex > 0;
    },
    editClosed({ row, rowIndex }) {
      clearInterval(this.timer);
      if (this.isAllPending) return;
      if (rowIndex == 0) {
        return false;
      }
      if (rowIndex !== -1) {
        row.yearTarget = this.$filterSpecialChars(row.yearTarget);
        row.workItemContent = this.$filterSpecialChars(row.workItemContent);
        if (this.isEditable) {
          if(this.$getRowExpandFlag()) this.tableData[rowIndex].expandRowFlag = false;
          this.refreshTable();
          this.save(row, rowIndex);
        }
      }
    },
    activeRow({ row, rowIndex }) {
      if (rowIndex == 0) return false;
      this.activedRow = row;
      this.rowIndex = rowIndex;
      clearInterval(this.timer);
      if (this.isEditable) {
        this.timer = setInterval(() => {
          this.saveAuto(row, rowIndex);
        }, 10000);
      }
    },
    saveAuto(row, index) {
      this.save(row, index);
    },
    save(row, index) {
      if (this.pending) return false;
      this.pending = true;
      let params = {
        ...this.tableData[index]
      };
      this.$ajax
        .post(this.$api.responsWork.detail.updateItem, params, { noLoading: true })
        .then((res) => {
          const item = res.data;
          if (!row.id && item.id) {
            row.id = item.id;
          }
          this.setSaveStatus('已保存')
          this.timeoutSave && clearTimeout(this.timeoutSave);
          this.timeoutSave = setTimeout(() => {
            this.setSaveStatus('')
          }, 1000, this);
        })
        .finally(() => {
          this.pending = false;
        });
    },
    setSaveStatus(status) {
      this.$emit('update:saveStatus', status);
    },
    async addRow() {
      if (!this.expandStatus) {
        this.expandStatus = true;
        //this.tableData = _.cloneDeep(this.cloneTableData);
        //this.cloneTableData = [{}];
      }
      
      const $table = this.$refs.detailTable;
      let newRowItem = this.newRow();
      newRowItem.workClassify = this.tableDetail.workClassify;
      this.tableData.push(newRowItem);
      await $table.setActiveRow(this.tableData[this.tableData.length - 1]);
    },
    async copyData(row) {
      const $table = this.$refs.detailTable;
      const item = _.cloneDeep(row);
      delete item._X_ID;
      delete item.id;
      item.status = 0;
      this.tableData.push(item);
      await $table.setActiveRow(this.tableData[this.tableData.length - 1]);
      
    },
    deleteData(row) {
      if (row.id) {
        this.$ajax.get(this.$api.responsWork.detail.detailItem, {id: row.id}).then(() => {
          this.activedRow = {};
          _.remove(this.tableData, t => t.id == row.id);
          this.tableData.splice(0, 0);
          clearInterval(this.timer);
          this.$message.success('删除成功');
        });
      } else {
        _.remove(this.tableData, t => t._X_ID == row._X_ID);
        this.tableData.splice(0, 0);
        clearInterval(this.timer);
        this.$message.success('删除成功');
      }
    },
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearTimeout(this.timeoutSave);
  }
}
</script>
<style lang="scss" scoped>
  .respons-detail-table {
    ::v-deep .header-table {
      user-select: text;
      .vxe-table--header-wrapper {
        background-color: $--bg-color-complete !important;
      }
      .vxe-table--body-wrapper {
        overflow: visible;
      }
      .main-row {
        .vxe-cell {
          padding: 0;
        }
      }
      .unfinished {
        .vxe-cell{
          color: rgb(254, 107, 104);
        }
      }
      .vxe-table--border-line {
        border-top: none;
      }
    }
    .type-add {
      height: 47px;
      background-color: $--color-bg-table-header;
      color: $--color-primary;
      font-size: 14px;
      padding: 0 15px;
      div {
        cursor: pointer;
        span {
          margin-right: 15px;
        }
        i.fold {
          margin-right: 5px;
        }
      }
      span {
        cursor: pointer;
      }
    }
  }
</style>
<style>
  .personal-response-weight-popper {
    width: 60px!important;
  }
</style>